import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

const whatsappNumber = "5555992338351";
const whatsappMessage = encodeURIComponent("Olá! Acabei de acessar o seu site e me interessei. Gostaria de agendar uma consulta.");

interface LinkItem {
  icon: string;
  label: string;
  style: "btn-primary" | "btn-secondary" | "btn-instagram";
  href: string;
  external: boolean;
  anchor?: string;
}

const links: LinkItem[] = [
  {
    href: `https://wa.me/${whatsappNumber}?text=${whatsappMessage}`,
    icon: "ri-whatsapp-line",
    deveGtag: true,
    label: "Agendar avaliação pelo WhatsApp",
    style: "btn-primary",
    external: true,
  },
  {
    href: "/",
    anchor: "procedimentos",
    icon: "ri-body-scan-line",
    label: "Procedimentos corporais",
    style: "btn-secondary",
    external: false,
  },
  {
    href: "/",
    anchor: "facial",
    icon: "ri-sparkling-2-line",
    label: "Procedimentos faciais",
    style: "btn-secondary",
    external: false,
  },
  {
    href: "/",
    anchor: "celulite",
    icon: "ri-focus-3-line",
    label: "Tratamento definitivo para celulite",
    style: "btn-secondary",
    external: false,
  },
  {
    href: "/",
    anchor: "emagrecimento",
    icon: "ri-seedling-line",
    label: "Emagrecimento e performance",
    style: "btn-secondary",
    external: false,
  },
  {
    href: "https://www.instagram.com/leo_dra_bumbum/",
    icon: "ri-instagram-line",
    label: "Instagram oficial",
    style: "btn-instagram",
    external: true,
  },
];

export default function LinksPage() {
  const navigate = useNavigate();

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "instant" });
    document.title = "Léo Dra. Bumbum | Links";
  }, []);

  function handleInternalLink(anchor?: string) {
    navigate("/");
    if (anchor) {
      setTimeout(() => {
        const el = document.getElementById(anchor);
        if (el) {
          el.scrollIntoView({ behavior: "smooth" });
        }
      }, 300);
    }
  }

  return (
    <div
      className="min-h-screen"
      style={{
        fontFamily: "'DM Sans', sans-serif",
        backgroundColor: "#faf8f5",
        backgroundImage:
          "radial-gradient(ellipse at 15% 10%, rgba(201,168,76,0.10) 0%, transparent 55%), radial-gradient(ellipse at 85% 85%, rgba(201,168,76,0.08) 0%, transparent 55%)",
      }}
    >
      <div className="max-w-[480px] mx-auto px-6 py-14 flex flex-col items-center">

        {/* Profile */}
        <div className="flex flex-col items-center mb-7">
          <div
            className="w-[110px] h-[110px] rounded-full p-[3px] mb-5"
            style={{
              background: "linear-gradient(135deg, #C9A84C, #f0d080, #C9A84C, #8B6914)",
              boxShadow: "0 4px 24px rgba(201,168,76,0.22)",
            }}
          >
            <img
              src="/img/IMG_8863.JPEG"
              alt="Dra. Leonida Fontoura - Léo Dra. Bumbum"
              className="w-full h-full rounded-full object-cover object-top"
              style={{ border: "3px solid #faf8f5" }}
            />
          </div>

          <h1
            className="text-center leading-tight mb-1"
            style={{ fontFamily: "'Playfair Display', serif", color: "#1a1a1a" }}
          >
            <span className="block text-[26px] font-light tracking-widest" style={{ color: "#1a1a1a" }}>Léo</span>
            <span className="block text-[30px] font-bold">
              <span style={{ color: "#C9A84C" }}>Dra.</span> Bumbum
            </span>
          </h1>

          <p
            className="text-[10.5px] text-center mt-3 leading-[1.95] tracking-[0.13em] uppercase font-medium"
            style={{ color: "#a08040" }}
          >
            Remodelação Glútea<br />
            Emagrecimento e Performance<br />
            Tratamento definitivo para Celulite<br />
            Atendimento RS &bull; SC
          </p>
        </div>

        {/* Divider */}
        <div className="flex items-center gap-2 w-full max-w-[280px] mb-7">
          <div
            className="flex-1 h-px"
            style={{ background: "linear-gradient(to right, transparent, rgba(201,168,76,0.45), transparent)" }}
          />
          <div className="w-[5px] h-[5px] rounded-full" style={{ background: "#C9A84C", opacity: 0.7 }} />
          <div
            className="flex-1 h-px"
            style={{ background: "linear-gradient(to right, transparent, rgba(201,168,76,0.45), transparent)" }}
          />
        </div>

        {/* Links */}
        <div className="w-full flex flex-col gap-3 mb-9">
          {links.map((link, i) => {
            const isPrimary = link.style === "btn-primary";
            const isInstagram = link.style === "btn-instagram";

            const baseStyle: React.CSSProperties = isPrimary
              ? {
                background: "linear-gradient(135deg, #f5e9b8 0%, #fdf4d0 50%, #f5e9b8 100%)",
                color: "#5a3e00",
                boxShadow: "0 6px 22px rgba(201,168,76,0.18)",
                border: "1px solid #e8d48a",
              }
              : isInstagram
                ? {
                  background: "#fff5f0",
                  color: "#2a2a2a",
                  border: "1px solid #f0d8c8",
                  boxShadow: "0 2px 12px rgba(201,168,76,0.06)",
                }
                : {
                  background: "#ffffff",
                  color: "#2a2a2a",
                  border: "1px solid #e8dfc8",
                  boxShadow: "0 2px 12px rgba(201,168,76,0.08)",
                };

            const iconStyle: React.CSSProperties = isPrimary
              ? { background: "rgba(0,0,0,0.10)", color: "#1a1200" }
              : { background: "rgba(201,168,76,0.10)", color: "#C9A84C" };

            if (link.external) {
              return (
                <a
                  key={i}
                  href={link.href}
                  target="_blank"
                  rel="noopener noreferrer"
                  onClick={(e) => {
                    if (link.deveGtag) {
                      e.preventDefault();
                      // @ts-ignore
                      window.gtag_report_conversion(link.href);
                    }
                  }}
                  className="flex items-center gap-3 w-full px-5 py-[17px] rounded-2xl no-underline cursor-pointer transition-all duration-200 hover:-translate-y-[2px] active:scale-[0.98] group"
                  style={baseStyle}
                >
                  <div
                    className="w-9 h-9 rounded-[9px] flex items-center justify-center flex-shrink-0 text-lg"
                    style={iconStyle}
                  >
                    <i className={link.icon}></i>
                  </div>
                  <span
                    className="flex-1 text-left text-[13px] font-semibold tracking-wider uppercase"
                    style={{ fontFamily: "'DM Sans', sans-serif" }}
                  >
                    {link.label}
                  </span>
                  <i
                    className="ri-arrow-right-line text-base flex-shrink-0 transition-all duration-200 group-hover:translate-x-1 group-hover:opacity-100"
                    style={{ color: isPrimary ? "#1a1200" : "#C9A84C", opacity: 0.4 }}
                  ></i>
                </a>
              );
            }

            return (
              <button
                key={i}
                type="button"
                onClick={() => handleInternalLink(link.anchor)}
                className="flex items-center gap-3 w-full px-5 py-[17px] rounded-2xl cursor-pointer transition-all duration-200 hover:-translate-y-[2px] active:scale-[0.98] group text-left"
                style={baseStyle}
              >
                <div
                  className="w-9 h-9 rounded-[9px] flex items-center justify-center flex-shrink-0 text-lg"
                  style={iconStyle}
                >
                  <i className={link.icon}></i>
                </div>
                <span
                  className="flex-1 text-left text-[13px] font-semibold tracking-wider uppercase"
                  style={{ fontFamily: "'DM Sans', sans-serif" }}
                >
                  {link.label}
                </span>
                <i
                  className="ri-arrow-right-line text-base flex-shrink-0 transition-all duration-200 group-hover:translate-x-1 group-hover:opacity-100"
                  style={{ color: "#C9A84C", opacity: 0.4 }}
                ></i>
              </button>
            );
          })}
        </div>

        {/* Footer */}
        <footer className="w-full text-center pt-5" style={{ borderTop: "1px solid #e8dfc8" }}>
          <p
            className="text-[13px] italic mb-1"
            style={{ fontFamily: "'Playfair Display', serif", color: "#a08040" }}
          >
            Dra. Leonida Hendges Fontoura
          </p>
          <p className="text-[11px] tracking-widest uppercase" style={{ color: "#c8b080" }}>
            CRM RS 58689 | CRM SC 43471
          </p>
        </footer>

      </div>
    </div>
  );
}
